import script from "./PanelLevel.vue?vue&type=script&setup=true&lang=js"
export * from "./PanelLevel.vue?vue&type=script&setup=true&lang=js"

import "./PanelLevel.vue?vue&type=style&index=0&id=9d433c7e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ga38som\\IdeaProjects\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d433c7e"]])

export default __exports__